"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../styles");

var _EDSContext = require("../EDSContext/EDSContext");

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableRow = _interopRequireDefault(require("../Table/TableRow"));

var _TableRow2 = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));

var _ChevronUp = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronDown"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _tokens = require("../styles/tokens");

var _excluded = ["classes", "children", "expandedRowClassName", "expandedRowContent", "TableRowProps", "ExpandedTableRowProps", "edsContext", "parentRowGroup", "expand"];

var styles = function styles(theme) {
  var _root;

  return {
    root: (_root = {
      height: '3rem'
    }, _root[theme.breakpoints.down('sm')] = {
      '&.table-row-expanded': {
        backgroundColor: theme.palette.grey[200]
      }
    }, _root),
    tableRowExpandedBackground: {
      backgroundColor: theme.palette.grey[200]
    },
    tableRowExpand: {
      padding: _tokens.spacing40 + " " + _tokens.spacing50
    },
    muiTableCellRoot: {
      '&:last-child': {
        paddingRight: _tokens.spacing40,
        textAlign: 'right'
      }
    },
    iconSize: {
      height: _tokens.sizingSmall,
      width: _tokens.sizingSmall
    },
    expandPadding: {
      paddingTop: _tokens.spacing20,
      paddingBottom: _tokens.spacing20
    }
  };
};

var TableExpandableRow = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(TableExpandableRow, _React$Component);

  function TableExpandableRow(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.toggleExpand = function (e) {
      if (e.type === 'keypress' && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();

        _this.updateState();
      } else if (e.type === 'click') {
        _this.updateState();
      }
    };

    _this.state = {
      expanded: false
    };
    return _this;
  }

  var _proto = TableExpandableRow.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    if (this.props.expand !== prevProps.expand) {
      this.setState(function (state) {
        return {
          expanded: _this2.props.expand
        };
      });
    }
  };

  _proto.updateState = function updateState() {
    this.setState(function (state) {
      return {
        expanded: !state.expanded
      };
    });
  };

  _proto.render = function render() {
    var _classnames,
        _this3 = this;

    var _this$props = this.props,
        classes = _this$props.classes,
        children = _this$props.children,
        expandedRowClassName = _this$props.expandedRowClassName,
        expandedRowContent = _this$props.expandedRowContent,
        TableRowProps = _this$props.TableRowProps,
        ExpandedTableRowProps = _this$props.ExpandedTableRowProps,
        edsContext = _this$props.edsContext,
        parentRowGroup = _this$props.parentRowGroup,
        expand = _this$props.expand,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
    var expanded = this.state.expanded;
    var expandLabel = expanded ? edsContext.formatMessage('component.Table.hide') : edsContext.formatMessage('component.Table.showMore');
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, (0, _extends2.default)({
      className: (0, _classnames2.default)(classes.root, (_classnames = {}, _classnames[classes.tableRowExpandedBackground] = expanded && expandedRowContent, _classnames['table-row-expanded'] = expanded, _classnames['not-table-row-expanded'] = !expanded && expandedRowContent, _classnames['table-expandable-row'] = expandedRowContent, _classnames)),
      parentRowGroup: parentRowGroup
    }, TableRowProps, rest), children, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      className: (0, _classnames2.default)(classes.expandPadding, 'expand-row-button', {
        'no-expanded-row-content': !expandedRowContent
      }),
      classes: {
        root: classes.muiTableCellRoot
      }
    }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      title: expandLabel,
      placement: edsContext.dir === 'rtl' ? 'right' : 'left'
    }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      className: "expand-icon-container",
      color: "gray",
      "aria-expanded": expanded,
      "aria-label": expandLabel,
      onClick: function onClick(e) {
        return _this3.toggleExpand(e);
      },
      tabIndex: 0
    }, expanded ? /*#__PURE__*/_react.default.createElement(_ChevronUp.default, {
      className: (0, _classnames2.default)(classes.iconSize, 'expand-icon')
    }) : /*#__PURE__*/_react.default.createElement(_ChevronDown.default, {
      className: (0, _classnames2.default)(classes.iconSize, 'expand-icon')
    }))))), expandedRowContent && expanded && /*#__PURE__*/_react.default.createElement(_TableRow2.default, (0, _extends2.default)({
      className: (0, _classnames2.default)(classes.tableRowExpandedBackground, expandedRowClassName, 'table-row-expanded-content')
    }, ExpandedTableRowProps), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      className: classes.tableRowExpand,
      colSpan: _react.default.Children.count(children) + 1 + (parentRowGroup === undefined ? 0 : 1)
    }, expandedRowContent)));
  };

  return TableExpandableRow;
}(_react.default.Component);

TableExpandableRow.muiName = 'TableExpandableRow';
TableExpandableRow.displayName = 'TableExpandableRow';
TableExpandableRow.propTypes = {
  /**
   * Common children are the TableCells with information you want to show on the TableRow.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * @ignore
   */
  classes: _propTypes.default.object,

  /**
   * This is the custom prop for developers to control the expand collapse.
   * Useful when you want to expand / collapse all section in one click.
   */
  expand: _propTypes.default.bool,

  /**
   * This is the actual content that should be shown when the TableExpandableRow is expanded.
   * When used for responsive table, you can choose not to supply any content.
   */
  expandedRowContent: _propTypes.default.node,

  /**
   * Custom string name to send to the TableRow that is shown when expanded.
   */
  expandedRowClassName: _propTypes.default.string,

  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,

  /**
   * @ignore
   */
  parentRowGroup: _propTypes.default.string,

  /**
   * Object of props to send to the TableRow with the toggle arrow.
   */
  TableRowProps: _propTypes.default.object,

  /**
   * Object of props to send to the TableRow that is shown when expanded.
   */
  ExpandedTableRowProps: _propTypes.default.object
};

var _default = (0, _EDSContext.withEDSContext)((0, _styles.withStyles)(styles)(TableExpandableRow));

exports.default = _default;